import React, { useState, useEffect } from 'react';
import SellerSatisfactionChart from '../../components/Seller/SellerSatisfactionChart/SellerSatisfactionChart';
import SellerReportBarChart from '../../components/Seller/SellerReportBarChart/SellerReportBarChart';
import { FaUserGroup } from "react-icons/fa6";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import axios from 'axios';
import { BASE_URL, USER_URL } from '../../constant/api';
import ProductList from '../../components/AdminDashboard/ProductList/ProductList ';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, AreaChart, Area } from 'recharts';

function SellerReports() {
    const [salesData, setSalesData] = useState({}); // Initialize as an object
    const [selectedYear, setSelectedYear] = useState(2024);
    const [filteredSalesData, setFilteredSalesData] = useState([]);

    // const satisfactionData = [
    //     { name: 'JAN', lastMonth: 2000, thisMonth: 10200 },
    //     { name: 'FEB', lastMonth: 2500, thisMonth: 6900 },
    //     { name: 'MAR', lastMonth: 3000, thisMonth: 6600 },
    //     { name: 'APR', lastMonth: 2200, thisMonth: 8500 },
    //     { name: 'MAY', lastMonth: 2500, thisMonth: 8000 },
    //     { name: 'JUN', lastMonth: 2300, thisMonth: 9500 },
    // ];

      const [satisfactionData, setSatisfactionData] = useState([]);

    const colors = {
        lastMonth: '#3B82F6',
        thisMonth: '#34D399',
    };



    const [products, setProducts] = useState([]);

    const fetchData = async (url, setState) => {
        try {
            const token = localStorage.getItem('token');
            const response = await USER_URL.get(url, {
                // headers: { 'Authorization': `Token ${token}` },
            });
            // console.log(response.data);
            if (response.data.Status === '1') {
                setState(response.data.Data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const fetchSatisfactionData = async () => {
            // const token = localStorage.getItem('token');
            // const headers = { Authorization: `Token ${token}` };

            try {
                const response = await USER_URL.get(
                    `/orders/seller/satisfaction/?year=${selectedYear}`,
                    // { headers }
                );
                const data = response.data.Data || [];
                console.log(response.data);
                setSatisfactionData(data);
            } catch (error) {
                console.error('Error fetching satisfaction data:', error);
                setSatisfactionData([]); // Ensure it always defaults to an empty array
            }
        };

        fetchSatisfactionData();
    }, [selectedYear]);


    useEffect(() => {
        fetchData(`/products/seller/top-selling/`, setProducts);

        // Fetch sales data
        fetchData(`/orders/seller/sales-by-year/?year=${selectedYear}`, (data) => {
            setSalesData((prev) => ({
                ...prev,
                [selectedYear]: data, // Update the sales data for the specific year
            }));
        });
    }, [selectedYear]);

    useEffect(() => {
        // Update filtered sales data when salesData or selectedYear changes
        if (salesData[selectedYear]) {
            setFilteredSalesData(salesData[selectedYear]);
        }
    }, [salesData, selectedYear]);

    const handleYearChange = (e) => {
        const year = parseInt(e.target.value, 10); // Ensure year is an integer
        setSelectedYear(year);
    };

    const getTotalSales = () => {
        return filteredSalesData.reduce((total, month) => total + month.sales, 0);
    };

      const CustomDot = (props) => {
    const { cx, cy, fill } = props;

    return (
      <circle
        cx={cx}
        cy={cy}
        r={6} // Set the radius
        fill={fill || "#00BFFF"} // Default fill color to a vibrant blue
        style={{
          filter: 'drop-shadow(0 0 4px rgba(0, 123, 255, 0.5))', // Glow effect
          cursor: 'pointer',
        }}
      />
    );
  };




    const renderStatCard = (icon, title, value, growth) => (
        <div className="flex justify-between items-center p-4 md:border-r-2">
            <div className="flex items-center space-x-4">
                <div className='text-brand-primary bg-[#E7F7F0] p-2 text-2xl md:text-xs rounded-lg'>
                    {icon}
                </div>
                <div>
                    <p className="font-semibold text-xs">{title}</p>
                    <p className="text-gray-600 text-xs line-clamp-1">{value}</p>
                </div>
            </div>
            <div className={`flex items-center text-xs ${growth > 0 ? 'text-green-500' : 'text-red-500'}`}>
                {growth > 0 ? <BsArrowUp className="mr-2" /> : <BsArrowDown className="mr-2" />}
                <p>{growth}%</p>
            </div>
        </div>
    );

    return (
        <div className="bg-white rounded-lg p-1 md:p-6">
            <div className="flex flex-col lg:flex-row lg:gap-6">
                <div className="flex-[3]">
                    <div className="mb-10">
                         <div className="border bg-white p-5 rounded-xl shadow-md mt-5">
                                      <div className="flex justify-between items-center mb-4">
                                        <h2 className="text-lg font-semibold text-gray-800">Customer Satisfaction</h2>
                                        <select
                                          value={selectedYear}
                                          onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                                          className="px-3 py-1 bg-gray-100 rounded-lg border border-gray-300 text-gray-600"
                                        >
                                          {[2022, 2023, 2024, 2025].map((year) => (
                                            <option key={year} value={year}>
                                              {year}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <ResponsiveContainer width="100%" height={250}>
                                        <AreaChart data={satisfactionData}>
                                          <defs>
                                            <linearGradient id="colorRating" x1="0" y1="0" x2="0" y2="1">
                                              <stop offset="5%" stopColor="#1E90FF" stopOpacity={0.5} />
                                              <stop offset="95%" stopColor="#1E90FF" stopOpacity={0} />
                                            </linearGradient>
                                          </defs>
                                          <CartesianGrid strokeDasharray="3 3" opacity={0.1} />
                                          <XAxis
                                            dataKey="month"
                                            tickFormatter={(month) => month.slice(0, 3)}
                                            tick={{ fontSize: 12 }}
                                            interval={0}
                                            padding={{ left: 10, right: 10 }}
                                          />
                                          <YAxis
                                            domain={[1, 5]} // Explicitly set range to 1-5
                                            ticks={[1, 2, 3, 4, 5]} // Ensure Y-axis shows 1, 2, 3, 4, 5
                                            tick={{ fontSize: 12 }}
                                          />
                                          <Tooltip />
                                          <Area
                                            type="monotone"
                                            dataKey="average_rating"
                                            fill="url(#colorRating)"
                                            stroke="#1E90FF"
                                            strokeWidth={3}
                                            fillOpacity={1}
                                            dot={<CustomDot fill="#1E90FF" />}
                                          />
                                        </AreaChart>
                                      </ResponsiveContainer>
                        
                        
                                    </div>
                        
                    </div>

                    <div className="mb-10 border-2 rounded-xl p-2 md:p-5">
                        <div className="flex flex-wrap  justify-between items-center mb-6">
                            <div>
                                <p className="text-lg font-semibold">Sales in Year</p>
                                <p className="text-xl">{getTotalSales()} sales</p>
                            </div>
                            <div>
                                <select
                                    className="border px-4 py-2 rounded-md w-full sm:w-auto"
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                >
                                    <option value="2025">2025</option>
                                    <option value="2024">2024</option>
                                    <option value="2023">2023</option>
                                </select>
                            </div>
                        </div>
                        <SellerReportBarChart data={filteredSalesData} />

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
                            {renderStatCard(
                                <FaUserGroup />,
                                "Total Customers",
                                "2930",
                                3
                            )}
                            {renderStatCard(
                                <FaUserGroup />,
                                "Total Revenue",
                                "₹2930",
                                -10
                            )}
                            {renderStatCard(
                                <FaUserGroup />,
                                "Bestsellers",
                                "Abcd Construction",
                                3
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex-[1] w-full lg:w-auto">
                    <div className="rounded-lg bg-white p-4">
                        <h3 className="mb-4 text-lg font-semibold">Top Selling Products</h3>
                        <div className="space-y-4 overflow-y-auto h-[500px] lg:h-[900px]">
                            {Array.isArray(products) && products.length > 0 ? (
                                products.map((product, index) => (
                                    <ProductList key={index} product={product} />
                                ))
                            ) : (
                                <p>No Products Found...</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SellerReports;
